<template>
  <v-card>
    <v-form @submit.prevent="submitEditTrip()" ref="editTripForm">
      <v-container>
        <v-layout row wrap>
          <dialog-header :title="'Edit'" :details="`Trip (Docket: ${trip.docket.id})`"></dialog-header>
          <flex-sub-header></flex-sub-header>

          <!-- TIP SPOIL -->
          <!-- TIP SPOIL -->
          <v-flex xs12 sm6>
            <v-autocomplete
              label="* Tip"
              :color="primaryNeutral"
              :items="filteredTips"
              @change="editedTrip.spoilId = null"
              v-model="editedTrip.tipId"
              item-text="name"
              item-value="id"
              :loading="loadingTips"
              :rules="tipRules"
              :prepend-icon="$store.state.global.pages.tip.icon"
              clearable
            ></v-autocomplete>
          </v-flex>
          <v-flex xs12 sm6>
            <v-autocomplete
              label="* Spoil"
              :color="primaryNeutral"
              :items="filteredSpoils"
              v-model="editedTrip.spoilId"
              item-text="name"
              item-value="id"
              :loading="loadingSpoils"
              :rules="spoilRules"
              :prepend-icon="$store.state.global.pages.spoil.icon"
              clearable
            ></v-autocomplete>
          </v-flex>

          <!-- HOURS -->
          <!-- HOURS -->
          <v-flex xs12>
            <div class="body-2 grey--text text--darken-1">Timesheet</div>
          </v-flex>
          <v-flex
            xs12
            class="flex-container-space-between grey--text"
            v-if="editedTrip.start"
          >Duration: {{getUTCTime(editedTrip.start)}} - {{getUTCTime(editedTrip.end)}}</v-flex>
          <v-flex xs6 class="grey--text">
            <v-text-field
              v-model="editedTrip.hours"
              label="Billable Hours"
              type="number"
              prepend-icon="access_time"
              autofocus
              :rules="hoursRules"
              :loading="loading"
            ></v-text-field>
          </v-flex>

          <v-flex xs3 class="grey--text">
            <v-text-field
              v-model="editedTrip.breaks"
              label="Breaks"
              type="number"
              prepend-icon="alarm_off"
              :loading="loading"
            ></v-text-field>
          </v-flex>
          <v-flex xs3 class="grey--text">
            <v-text-field
              v-model="editedTrip.travel"
              label="Travel"
              type="number"
              prepend-icon="add_alarm"
              :loading="loading"
            ></v-text-field>
          </v-flex>

          <!-- QTY -->
          <!-- QTY -->
          <v-flex xs12>
            <div class="body-2 grey--text text--darken-1">Quantity</div>
          </v-flex>
          <v-flex xs12 class="grey--text">
            <v-text-field
              v-model="editedTrip.qty"
              label="Quantity"
              type="number"
              prepend-icon="chevron_right"
              :rules="qtyRules"
              :loading="loading"
            ></v-text-field>
          </v-flex>

          <v-flex xs12>
            <div class="body-2 grey--text text--darken-1">Waived Amount</div>
          </v-flex>
          <v-flex xs12 class="grey--text">
            <v-text-field 
              v-model.number="editedTrip.waivedAmount" 
              label="Waived Amount" 
              type="number" 
              prepend-icon="attach_money"
              :rules="waivedAmountRules"
              :loading="loading"
            ></v-text-field>
          </v-flex>

          <!-- OPTIONS -->
          <!-- OPTIONS -->
          <v-flex sm4 xs6 class="grey--text" v-if="!editedTrip.useNightRate">
            <v-switch
              :color="$store.state.global.pages.docket.color"
              v-model="editedTrip.useAltRate"
              label="Use Alt Rate"
            ></v-switch>
          </v-flex>
          <v-flex sm4 xs6 class="grey--text" v-if="!editedTrip.useAltRate">
            <v-switch
              :color="$store.state.global.pages.docket.color"
              v-model="editedTrip.useNightRate"
              label="Use Night Rate"
            ></v-switch>
          </v-flex>
          <v-flex
            sm4
            xs6
            class="grey--text"
            v-if="$store.state.user.userAuthClass.name=='Administrator'"
          >
            <v-switch
              :color="$store.state.global.pages.docket.color"
              v-model="repriceTrip"
              :label="`Reprice Trip (Rate: ${editedTrip.rateId})`"
            ></v-switch>
          </v-flex>

          <!-- WEIGHT -->
          <!-- WEIGHT -->
          <v-flex xs12>
            <div class="body-2 grey--text text--darken-1">Mass Declaration</div>
          </v-flex>

          <v-flex xs4 class="flex-container-space-between">
            <v-text-field
              prepend-icon="shopping_basket"
              v-model="editedTrip.siteWeight"
              label="Tip / Weighbridge Weight"
              type="number"
              :rules="siteWeightRules"
              :loading="loading"
            ></v-text-field>
          </v-flex>
          <v-flex xs4 class="flex-container-space-between">
            <v-text-field
              v-model="editedTrip.tipWeight"
              label="Site / Load Rite Weight"
              type="number"
              :rules="tipWeightRules"
              :loading="loading"
            ></v-text-field>
          </v-flex>
          <v-flex xs4 class="flex-container-space-between">
            <v-text-field
              v-model="editedTrip.scaleWeight"
              label="Truck / Scale Weight"
              type="number"
              :rules="scaleWeightRules"
              :loading="loading"
            ></v-text-field>
          </v-flex>

          <!-- W/B DOCKET # -->
          <v-flex xs12 sm4>
            <v-text-field
              color="indigo"
              label="W/B Docket #"
              prepend-icon="note"
              v-model="editedTrip.wbDocketNumber"
              :rules="wbDocketNumberRules"
            ></v-text-field>
          </v-flex>

          <!-- TRIP NOTES -->
          <v-flex xs12 sm8 class="flex-container-space-between">
            <v-text-field
              prepend-icon="note"
              v-model="editedTrip.notes"
              label="Trip Notes"
              type="text"
              :rules="noteRules"
            ></v-text-field>
          </v-flex>

          <!-- COST -->
          <!-- COST -->
          <template v-if="userShowCost">
            <v-flex xs12>
              <div class="body-2 grey--text text--darken-1">Cost</div>
            </v-flex>
            <v-flex xs12 sm4 class="flex-container-space-between">
              <v-text-field
                type="number"
                label="Cost price *"
                :rules="costPriceRules"
                :disabled="$store.state.user.userAuthClass.name!='Administrator'"
                v-model="editedTrip.costPrice"
                prepend-icon="attach_money"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm4 class="flex-container-space-between">
              <span class="pt-4 pr-3">/</span>
              <v-autocomplete
                label="Cost unit"
                :items="units"
                :disabled="$store.state.user.userAuthClass.name!='Administrator'"
                v-model="editedTrip.costUnit"
                no-data-text="An error occured"
                color="indigo"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs12 sm4 class="flex-container-space-between">
              <v-text-field
                disabled
                prepend-icon="attach_money"
                :value="editedTripCostTotal.toFixed(2)"
                label="Cost Total"
                type="number"
                :loading="loading"
              ></v-text-field>
            </v-flex>
          </template>

          <!-- SELL -->
          <!-- SELL -->
          <template v-if="userShowSell">
            <v-flex xs12>
              <div class="body-2 grey--text text--darken-1">Sell</div>
            </v-flex>
            <v-flex xs4 class="flex-container-space-between">
              <v-text-field
                type="number"
                label="Sell price *"
                :rules="sellPriceRules"
                :disabled="editSellPrice"
                v-model="editedTrip.sellPrice"
                prepend-icon="attach_money"
              ></v-text-field>
            </v-flex>
            <v-flex xs4 class="flex-container-space-between">
              <span class="pt-4 pr-3">/</span>
              <v-autocomplete
                label="Sell unit"
                :items="units"
                :disabled="$store.state.user.userAuthClass.name!='Administrator'"
                v-model="editedTrip.sellUnit"
                no-data-text="An error occured"
                color="indigo"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs4 class="flex-container-space-between">
              <v-text-field
                disabled
                prepend-icon="attach_money"
                :value="editedTripSellTotal.toFixed(2)"
                label="Sell Total"
                type="number"
                :loading="loading"
              ></v-text-field>
            </v-flex>
          </template>

          <!-- CONFIRMATIONS -->
          <!-- CONFIRMATIONS -->
          <v-flex xs12>
            <div class="body-2 grey--text text--darken-1">Trip Confirmations</div>
          </v-flex>
          <v-flex xs4 class="flex-container-space-between">
            <v-autocomplete
              prepend-icon="gps_fixed"
              label="GPS Status"
              :items="statusOptions"
              v-model="editedTrip.GPSConfirmed"
              color="indigo"
            ></v-autocomplete>
          </v-flex>
          <v-flex xs8 class="flex-container-space-between">
            <v-text-field
              v-model="editedTrip.GPSNotes"
              label="GPS notes"
              type="text"
              :loading="loading"
            ></v-text-field>
          </v-flex>
          <v-flex xs4 class="flex-container-space-between">
            <v-autocomplete
              prepend-icon="shopping_basket"
              label="Mass Declaration Status"
              :items="statusOptions"
              v-model="editedTrip.massDeclarationConfirmed"
              color="indigo"
            ></v-autocomplete>
          </v-flex>
          <v-flex xs8 class="flex-container-space-between">
            <v-text-field
              v-model="editedTrip.massDeclarationNotes"
              label="Mass declaration notes"
              type="text"
              :loading="loading"
            ></v-text-field>
          </v-flex>
          <v-flex xs4 class="flex-container-space-between">
            <v-autocomplete
              prepend-icon="delete_sweep"
              label="Tipping Docket Status"
              :items="statusOptions"
              v-model="editedTrip.tippingDocketConfirmed"
              color="indigo"
            ></v-autocomplete>
          </v-flex>
          <v-flex xs8 class="flex-container-space-between">
            <v-text-field
              v-model="editedTrip.tippingDocketNotes"
              label="Tipping docket notes"
              type="text"
              :loading="loading"
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <div v-if="different">
          <v-btn :color="primaryGrey" flat @click="discard()">Discard?</v-btn>
          <v-btn :color="primaryGreen" flat type="submit" :loading="loading">Save</v-btn>
        </div>
        <div v-else>
          <v-btn :color="primaryGrey" flat @click="close()">Close</v-btn>
        </div>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import Store from '@/store/computed/storeHelpers'
import DocketService from '@/services/requests/docketService'

// MIXINS
import TripEditValidation from '@/services/validation/tripEditValidation'
import FormatDates from '@/services/mixins/formatDates'
import getTips from '@/services/mixins/getMasterFiles/getTips'
import getSpoils from '@/services/mixins/getMasterFiles/getSpoils'
import FilterTipSpoils from '@/services/mixins/filterTipSpoils'

// COMPONENTS
import DialogHeader from '@/components/ui/dialogHeader'

export default {
  mixins: [
    TripEditValidation,
    FormatDates,
    getTips,
    getSpoils,
    FilterTipSpoils
  ],
  components: {
    DialogHeader
  },
  data() {
    return {
      prefix: 'editedTrip',
      editedTrip: Object.assign({}, this.trip),
      loading: false,
      units: ['TONNE', 'HOUR', 'DAY', 'EA'],
      statusOptions: ['CONFIRMED', 'REQUIRED', 'REVIEW', 'NOT SET'],
      // rateTypes: ["Standard", "Alt", "Night"],
      repriceTrip: false
    }
  },
  methods: {
    close() {
      this.$emit('close')
    },
    discard() {
      this.editedTrip = Object.assign({}, this.trip)
      this.close()
    },
    submitEditTrip() {
      if (!this.$refs.editTripForm.validate()) {
        this.snack({ text: 'Please correct form errors', color: 'red' })
        return
      }
      this.save()
    },
    save() {
      this.loading = true
      this.editedTrip.sellTotal = this.editedTripSellTotal
      this.editedTrip.costTotal = this.editedTripCostTotal
      this.editedTrip.edit = true
      this.editedTrip.repriceTrip = this.repriceTrip
      // this.editedTrip.tipId = this.tipId
      // this.editedTrip.spoilId = this.spoilId
      DocketService.updateTrip(this.editedTrip)
        .then(result => {
          result.data.result.trip.updated = true
          this.$store.commit('trips/updateArrayStateByValue', {
            prop: 'trips',
            value: this.trip,
            editedValue: result.data.result.trip
          })
          this.editedTrip = Object.assign({}, result.data.result.trip)
          this.repriceTrip = false
          this.editedTrip.edit = false
          this.editedTrip.repriceTrip = false
          this.snack({ text: 'Trip was edited!', color: 'green' })
          this.loading = false
          this.close()
        })
        .catch(err => {
          this.loading = false
          console.log(err)
          this.snack({ text: err.response.data.message, color: 'red' })
          //this.snackError();
        })
    }
  },
  computed: {
    projectId() {
      return this.editedTrip.docket.site.projectId
    },
    tipId() {
      return this.editedTrip.tipId
    },
    spoilId() {
      return this.editedTrip.spoilId
    },
    editSellPrice() {
      if (this.editedTrip.spoilId == 34) {
        return false
      } else {
        return this.$store.state.user.userAuthClass.name != 'Administrator'
      }
    },
    editedTripCostTotal() {
      if (this.editedTrip.costUnit == 'TONNE') {
        return this.editedTrip.siteWeight * this.editedTrip.costPrice
      }
      if (this.editedTrip.costUnit == 'HOUR') {
        return this.editedTrip.hours * this.editedTrip.costPrice
      }
      if (this.editedTrip.costUnit == 'EA') {
        return this.editedTrip.qty * this.editedTrip.costPrice
      }
      if (this.editedTrip.costUnit == 'DAY') {
        return this.editedTrip.qty * this.editedTrip.costPrice
      }
    },
    editedTripSellTotal() {
      if (this.editedTrip.sellUnit == 'TONNE') {
        return this.editedTrip.siteWeight * this.editedTrip.sellPrice
      }
      if (this.editedTrip.sellUnit == 'HOUR') {
        return this.editedTrip.hours * this.editedTrip.sellPrice
      }
      if (this.editedTrip.sellUnit == 'EA') {
        return this.editedTrip.qty * this.editedTrip.sellPrice
      }
      if (this.editedTrip.sellUnit == 'DAY') {
        return this.editedTrip.qty * this.editedTrip.sellPrice
      }
    },
    different() {
      if (!this._.isEqual(this.trip, this.editedTrip) || this.repriceTrip) {
        return true
      } else {
        return false
      }
    }
  },
  mounted() {
    // (this.editedTrip = Object.assign({}, this.trip)),
    //   (this.tipId = this.editedTrip.tipId);
    // (this.spoilId = this.editedTrip.spoilId),
    //   (this.projectId = this.editedTrip.docket.site.projectId);
    this.editedTrip = Object.assign({}, this.trip)
    // console.log('PROJECT ID FROM EDIT TRIP', this.projectId)
  },
  props: {
    trip: Object
  },
  watch: {
    editedTrip(val) {
      if (!!this.commitDocket) {
        this.submitDocket()
        this.commitDocket = false
      }
    }
  }
}
</script>

<style>
</style>
